import Aos from "aos";
import { useEffect } from "react";

const SolarFinancingHero = () => {
    const gotoApply = () => {
        window.open("https://app.checkoff.finance/", "_blank");
    };
    useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);
    return (
        <section className="solar-financing-container">

            <section className="hero-section" data-aos="fade-in">
                <div className="hero-content">
                    <h1 data-aos="fade-up">Get solar financing</h1>
                    <p data-aos="fade-up" data-aos-delay="200">
                        With rising fuel prices and unreliable power supply, most people want to switch to solar.
                        Checkoff Finance offers up to ₦6 million for salary earners and up to ₦100 million for businesses.
                        Spread payments for up to 24 months.
                    </p>
                    <button className="btn-apply" onClick={gotoApply}>
                        Apply Now
                    </button>
                </div>
            </section>

            <section className="stats-section container " data-aos="fade-in">
                <div className="stat-item" data-aos="fade-up">
                    <div className="stat-number">260+</div>
                    <div className="stat-label">Total Customers</div>
                </div>
                <div className="stat-item" data-aos="fade-up" data-aos-delay="200">
                    <div className="stat-number">47+</div>
                    <div className="stat-label">Solar Vendor Partners</div>
                </div>
                <div className="stat-item" data-aos="fade-up" data-aos-delay="400">
                    <div className="stat-number">13+</div>
                    <div className="stat-label">States Covered</div>
                </div>
                <div className="stat-item" data-aos="fade-up" data-aos-delay="600">
                    <div className="stat-number">₦1.13B</div>
                    <div className="stat-label">Solar Projects Financed</div>
                </div>
            </section>
        </section>
    );
};

export default SolarFinancingHero;
